import { colors } from '../theme/colors';
import type { IconName } from '../primitives/Icon';

/** String union matching itinerary-types TransportMode — defined locally to avoid cross-lib dep. */
export type TransportMode =
  | 'walk' | 'car' | 'metro' | 'train' | 'bus'
  | 'bike' | 'taxi' | 'ferry' | 'flight' | 'other';

export const MODE_LABELS: Record<TransportMode, string> = {
  walk: 'Walk', car: 'Car', metro: 'Metro', train: 'Train', bus: 'Bus',
  bike: 'Bike', taxi: 'Taxi', ferry: 'Ferry', flight: 'Flight', other: 'Other',
};

export const MODE_ICONS: Record<TransportMode, IconName> = {
  walk: 'directions-walk', car: 'directions-car', metro: 'subway', train: 'train',
  bus: 'directions-bus', bike: 'directions-bike', taxi: 'local-taxi',
  ferry: 'directions-boat', flight: 'flight', other: 'more-horiz',
};

export const MODE_COLORS: Record<TransportMode, string> = {
  walk: colors.accentGreen, car: colors.accentCerulean, metro: '#9C27B0',
  train: colors.accentYellow, bus: colors.accentCrimson, bike: '#4CAF50',
  taxi: '#FFC107', ferry: '#00BCD4', flight: '#2196F3', other: '#9E9E9E',
};
